module.exports = {
      id: "game-shop-usage",
      viewBox: "0 0 48.679 33.19",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#game-shop",
      toString: function () {
        return this.url;
      }
    }